<script>

/**
 * Nav-bar Component
 */
export default {
  props: {
    resource: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {};
  },
  mounted() {
  }
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table table-borderless">
      <tbody>
      <tr>
        <th scope="row">Enable :</th>
        <td>
          <b-badge v-if="resource.enable" variant="success">activé</b-badge>
          <b-badge v-if="!resource.enable" variant="danger">désactivé</b-badge>
        </td>
      </tr>
      <tr>
        <th scope="row">Full Name :</th>
        <td>{{ resource.first_name }} <b>{{ resource.last_name }}</b></td>
      </tr>
      <tr>
        <th scope="row">E-mail :</th>
        <td><a :href="`mailto:${resource.email}`">{{ resource.email }}</a></td>
      </tr>
      <tr>
        <th scope="row">Login :</th>
        <td>{{ resource.login }}</td>
      </tr>
      <tr>
        <th scope="row">Address :</th>
        <td><small>{{ resource.address }}</small>
          <span v-if="resource.additional_address"><small>
              <br>{{ resource.additional_address }}</small></span>
          <br><small>{{ resource.zip_code }} {{ resource.city }}</small></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
